import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const getChatbotLicenceBusinessessService = async () => {
  const apiPath = 'chatbot-analytics/licences';

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };

  const signedRequest = await createSignedRequest(request);
  const response = await fetch(signedRequest.url, {
    method: signedRequest.method,
    headers: signedRequest.headers,
  });

  return await response.json();
};

export const getChatbotBusinessesAnalyticsService = async (
  businessId,
  yearMonth
) => {
  const apiPath = `chatbot-analytics/${businessId}/${yearMonth}`;

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };

  const signedRequest = await createSignedRequest(request);
  const response = await fetch(signedRequest.url, {
    method: signedRequest.method,
    headers: signedRequest.headers,
  });

  return await response.json();
};

export const chatbotThreadSendFeedbackService = async (
  businessId,
  yearMonth,
  feedback
) => {
  const apiPath = `chatbot-analytics/feedback`;

  console.log('chatbotThreadSendFeedbackService');
  console.log({ businessId, yearMonth, feedback });
  const bodyItemToSend = { businessId, yearMonth, feedback };

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PUT',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyItemToSend),
    data: bodyItemToSend,
  };

  const signedRequest = await createSignedRequest(request);

  const res = await axios(signedRequest);

  return res.data;
};

export const activateChatbotLicenceService = async ({
  businessId,
  businessName,
}) => {
  const apiPath = `chatbot-analytics/activate-licence`;

  console.log('activateChatbotLicenceService');
  console.log({ businessId, businessName });
  const bodyItemToSend = { businessId, businessName };

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyItemToSend),
    data: bodyItemToSend,
  };

  const signedRequest = await createSignedRequest(request);

  const res = await axios(signedRequest);

  return res.data;
};

export const cancelChatbotLicenceService = async (businessId) => {
  const apiPath = `chatbot-analytics/cancel-licence`;

  console.log('cancelChatbotLicenceService');
  console.log({ businessId });
  const bodyItemToSend = { businessId };

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PUT',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyItemToSend),
    data: bodyItemToSend,
  };

  const signedRequest = await createSignedRequest(request);

  const res = await axios(signedRequest);

  return res.data;
};
